<template>
  <nav>
    <div>
      <div class="top-header-mobile">
        <div>
          <div class="mobile-header-options">
            <div class="menu-icon" @click="open = !open">
              <span
                class="material-icons"
                style="color: #000"
                v-if="open == false"
              >
                menu
              </span>
              <span
                class="material-icons"
                style="color: #000"
                v-if="open == true"
              >
                close
              </span>
            </div>
            <div class="logo">
              <a href="/" class="logo">
                <div class="image-logo-mobile"></div>
              </a>
            </div>
            <div class="menu-icon-options">
              <!-- <div>
                <span class="material-icons" style="color: #000"> search </span>
              </div> -->
              <div>
                <a href="/login">
                  <span class="material-icons" style="color: #000">
                    person
                  </span>
                </a>
              </div>
              <div>
                <a href="/sacola">
                  <span class="material-icons" style="color: #000">
                    shopping_bag
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sandwich" v-if="open == true">
        <div v-for="item in categorias" :key="item._id" class="menu-items">
          <a :href="`/${item.nome.toLowerCase()}?p=1`">{{ item.nome }}</a>
          <!-- <DropDown :title="item.nome" :items="item.sub" /> -->
        </div>
      </div>
    </div>
    <div>
      <div class="top-header">
        <a href="/#" class="image-logo-style">
          <div class="image-logo"></div>
        </a>
        <!-- <img
        class="image-logo"
        src="../assets/logo.png"
        alt="Empório das Marcas"
      /> -->
        <div class="menu-user">
          <div>
            <a href="/login">
              <span class="material-icons" style="color: #000"> person </span>
            </a>
          </div>
          <div>
            <!-- <a href="/sacola">
              <span class="material-icons" style="color: #000">
                shopping_bag
              </span>
            </a> -->
          </div>
        </div>
      </div>
      <!-- <div class="menu-items-component">
        <div v-for="item in categorias" :key="item._id" class="menu-items">
          <a href="#">{{item.nome}}</a>
          <DropDown :title="item.nome" :items="item.sub" />
        </div>
      </div> -->
    </div>
  </nav>
</template>

<script>
// import DropDown from "./DropDown";
export default {
  name: "navbar",
  components: {
    // DropDown,
  },
  data() {
    return {
      open: false,
      categorias: [],
      subcategorias: [],
      services: [
        {
          title: "Web",
          link: "#",
        },
        {
          title: "Design",
          link: "#",
        },
        {
          title: "Videos",
          link: "#",
        },
      ],
    };
  },
  async beforeMount() {
    this.getCategorias();
  },
  methods: {
    async getCategorias() {
      try {
        let res = await this.$http.get("/opens/categorias");
        let cat = res.data.categorias;
        this.getSubCategorias(cat);
      } catch (err) {
        // console.log(err);
      }
    },
    async getSubCategorias(cat) {
      try {
        let res = await this.$http.get(`/opens/subcategorias`);
        // console.log(res.data);
        let todas = res.data.subcategorias;
        for (let o of cat) {
          let unicas = [[], [], [], []];

          let coluna = 0;

          for (let e of todas) {
            if (e && e.categoria && e.categoria == o._id) {
              let added = false;
              for (let p of unicas) {
                for (let q of p) {
                  if (q._id == e._id) {
                    added = true;
                  }
                }
              }
              if (!added) {
                e.nome_cat = o.nome;
                unicas[coluna].push(e);
                switch (coluna) {
                  case 0:
                    coluna = 1;
                    break;
                  case 1:
                    coluna = 2;
                    break;
                  case 2:
                    coluna = 3;
                    break;
                  case 3:
                    coluna = 0;
                    break;
                  default:
                    coluna = 0;
                    break;
                }
              }
            }
          }

          console.log(unicas);

          let t_altura = unicas[0].length;
          let t_larg = unicas.length;

          let maior = t_altura > t_larg ? t_altura : t_larg;

          for (let i = 0; i < maior; i++) {
            for (let j = 0; j < maior; j++) {
              if (!unicas[i][j]) {
                unicas[i][j] = { nome: "", _id: "" };
              }
            }
          }

          o.sub = unicas;
        }

        console.log(cat);

        this.categorias = cat;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style>
nav {
  /* display: flex; */
  align-items: center;
  justify-items: center;
}

nav .top-header {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  justify-items: right;
}

nav .menu-items {
  color: #000;
  padding: 10px 20px;
  position: relative;
  text-align: center;
  border-bottom: 3px solid transparent;
  display: flex;
  transition: 0.4s;
}

nav .menu-items-component {
  color: #000;
  padding: 10px 20px;
  position: relative;
  text-align: center;
  border-bottom: 3px solid transparent;
  display: flex;
  width: 70%;
  font-size: 12px;
  transition: 0.4s;
}

nav .menu-items.active,
nav .menu-items:hover {
  background: #fff;
}

nav .menu-items a {
  color: inherit;
  text-decoration: none;
}

nav .image-logo {
  position: relative;
  left: 45%;
  width: 100px;
  height: 100px;
  background-image: url("../assets/logo.png");
  background-repeat: no-repeat;
  background-size: contain;
}

nav .image-logo-style {
  position: relative;
  left: 45%;
  width: 100px;
  height: 100px;
}

nav .image-logo-mobile {
  position: relative;
  width: 50px;
  height: 50px;
  background-image: url("../assets/logo.png");
  background-repeat: no-repeat;
  background-size: contain;
}

nav .menu-user {
  position: relative;
  width: 150px;
  padding: 10px 20px;
  display: flex;
}

nav .mobile-header-options {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

nav .mobile-header-options .menu-icon span {
  display: flex;
  padding: 20px;
  justify-items: flex-start;
  flex-direction: row;
}

nav .mobile-header-options .menu-icon-options {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}

nav .mobile-header-options .logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile {
  width: 100%;
}

@media screen and (max-width: 800px) {
  nav .top-header-mobile {
    display: flex;
  }

  nav .menu-items-component {
    display: none;
  }

  nav .top-header {
    display: none;
  }

  nav .sandwich {
    background-color: white;
    height: 100%;
    width: 100%;
    position: absolute;
  }
}

@media screen and (min-width: 801px) {
  nav .top-header-mobile {
    display: none;
  }
}
</style>